import scriptjs from 'scriptjs';
import Forms from './Forms';
import LiveSearch from './LiveSearch';
import { SearchForm } from './SearchForm';
import jQuery from 'jquery';
export default class DynamicSearch {
    constructor(section) {
        this.$el = jQuery(section.el);
        this.settings = section.data.settings;
        this.search = null;
        this.$scripts = jQuery('[data-scripts]');
        this.$searchField = this.$el.find('[data-live-search]');
        this.forms = new Forms(this.$el);
        if (this.settings.live_search.enable) {
            scriptjs(this.$scripts.data('shopify-api-url'), () => {
                this.search = new LiveSearch({
                    el: this.$searchField,
                    header: this.$el,
                }, Object.assign(Object.assign({}, this.settings.live_search), { use_dimmer: false }));
            });
        }
        else {
            this.search = new SearchForm(this.$searchField);
        }
    }
    onSectionUnload() {
        var _a;
        (_a = this.search) === null || _a === void 0 ? void 0 : _a.unload();
        this.forms.unload();
    }
}
